import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import ClientTransactionsTable from "./components/ClientTransactionsTable";
import PageWrapper from "app/modules/shared/PageWrapper";

const ClientTransactionsTablePage: React.FC = () => {
  return (
    <CPLAnalytics pageName="Client Transactions">
      <PageWrapper title="Transactions" backTo="/accounts" data-test-id="client-transactions__back-button">
        <ClientTransactionsTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default ClientTransactionsTablePage;
